export const getEnv = () => {
  const curHost = window.location.host
  if (isLocalEnv) {
    return 'dev'
  } else if (curHost.indexOf('-staging') > -1) {
    return 'staging'
  } else if (curHost.indexOf('-preview') > -1) {
    return 'preview'
  } else {
    return 'production'
  }
}

export const isLocalEnv =
  window.location.host.indexOf('localhost') > -1 || isLocalIp()

export function isLocalIp() {
  return !!window.location.hostname.match(
    /^127\.|10\.|192\.168|172\.(1[6-9]|2|3[01])$/
  )
}
